module.exports = __webpack_public_path__ + "static/media/robot.9b76a403.png";